export default __webpack_public_path__ + "static/media/rote_patrona_portrait.fc74401e.jpg";